
// Små svg-ikoner:

//################################################################################################

//import kugghjul from '../content/images/svg/feather/settings.svg';

// Fill = DekorfärgLogo, fast lite mörkare och lite desaturerad:
const loggaSnigel =
	`<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24"
		style="
			overflow:visible;
			stroke-linecap:round;
			stroke-linejoin:round;
			stroke-miterlimit:10;
			fill:#ec5f13;
			stroke-width:0;
			width: 100%;
			height: 100%;
		">
		<path class="a" d="M14.7,22.712c-.03.542-1.646.7-1.982.732a10.164,10.164,0,0,1-4.589-.595A11.18,11.18,0,0,1,1,14.431,12.02,12.02,0,0,1,4.154,3.974,11.934,11.934,0,0,1,14.382.6a9.943,9.943,0,0,1,8.036,5.943,8.68,8.68,0,0,1-2.807,10.614c-3.069,2.17-7.974,2.138-9.834-1.64a6.045,6.045,0,0,1-.7-2.552c0-.41.059-1.519.642-1.594.605-.077,1.257,1.189,1.556,1.568A4.034,4.034,0,0,0,14,14.786a3.415,3.415,0,0,0,3-1.526,4.113,4.113,0,0,0-.3-4.907,5.907,5.907,0,0,0-7.37-1.008,7.429,7.429,0,0,0-2.627,9.434c.918,1.99,2.923,3.309,4.863,4.205.719.331,1.462.6,2.182.928C14.051,22.047,14.719,22.292,14.7,22.712Z" transform="translate(-0.8 -0.5)"/>
	</svg>`;

// OLD fyrkantigare:
//		<polyline points="3 6 5 6 21 6"></polyline>
//		<path d="M19 6v14a2 2 0 0 1-2 2H7a2 2 0 0 1-2-2V6m3 0V4a2 2 0 0 1 2-2h4a2 2 0 0 1 2 2v2"></path>
const papperskorg =
	`<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24"
		style="
			overflow:visible;
			stroke-linecap:round;
			stroke-linejoin:round;
			stroke-miterlimit:10;
			fill:none;
			stroke:currentColor;
			stroke-width:1.5;
			width: 100%;
			height: 100%;
		">
		<polyline points="3,6 5,6 21,6 "/>
		<path d="M19,6l-1.2,14c0,1.1-0.9,2-2,2H8.2c-1.1,0-2-0.9-2-2L5,6 M8,6V4c0-1.1,0.9-2,2-2h4c1.1,0,2,0.9,2,2v2"/>
</svg>`;

const karta =
	`<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24"
		style="
			overflow:visible;
			stroke-linecap:round;
			stroke-linejoin:round;
			stroke-miterlimit:10;
			fill:none;
			stroke:currentColor;
			stroke-width:1.5;
			width: 100%;
			height: 100%;
		">
		<polygon points="1 6 1 22 8 18 16 22 23 18 23 2 16 6 8 2 1 6"></polygon>
		<line x1="8" y1="2" x2="8" y2="18"></line>
		<line x1="16" y1="6" x2="16" y2="22"></line>
	</svg>`;

const pennaRitar =
	`<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24"
		style="
			overflow:visible;
			stroke-linecap:round;
			stroke-linejoin:round;
			stroke-miterlimit:10;
			fill:none;
			stroke:currentColor;
			stroke-width:1.5;
			width: 100%;
			height: 100%;
		">
		<polygon points="14 2 18 6 7 17 3 17 3 13 14 2"></polygon>
		<line x1="3" y1="22" x2="21" y2="22"></line>
	</svg>`;

const kryss =
	`<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24"
		style="
			overflow:visible;
			stroke-linecap:round;
			stroke-linejoin:round;
			stroke-miterlimit:10;
			fill:none;
			stroke:currentColor;
			stroke-width:1.5;
			width: 100%;
			height: 100%;
		">
		<line x1="18" y1="6" x2="6" y2="18"></line>
		<line x1="6" y1="6" x2="18" y2="18"></line>
	</svg>`;

const burgare =
	`<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24"
		style="
			overflow:visible;
			stroke-linecap:round;
			stroke-linejoin:round;
			stroke-miterlimit:10;
			fill:none;
			stroke:currentColor;
			stroke-width:1.5;
			width: 100%;
			height: 100%;
		">
		<line x1="3" y1="12" x2="21" y2="12"></line>
		<line x1="3" y1="6" x2="21" y2="6"></line>
		<line x1="3" y1="18" x2="21" y2="18"></line>
	</svg>`;

const burgarePunkter =
	`<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24"
		style="
			overflow:visible;
			stroke-linecap:round;
			stroke-linejoin:round;
			stroke-miterlimit:10;
			fill:currentColor;
			stroke:currentColor;
			stroke-width:1;
			width: 100%;
			height: 100%;
		">
		<circle cx="12" cy="12" r="1"></circle>
		<circle cx="12" cy="5" r="1"></circle>
		<circle cx="12" cy="19" r="1"></circle>
	</svg>`;

// Tidigare: :style="chevronStyle" på polyline. Nu sätts den inline i <eui-collapsible> ist:
// transform-origin och transition nedan, på svg OCH child polyline är till för att
// – transform: scale(..) ska kunna gölras på svg och
// – transform: rotate(..) ska kunna göras på child plyline.
const chevronNer =
	`<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24"
		style="
			overflow:visible;
			stroke-linecap:round;
			stroke-linejoin:round;
			stroke-miterlimit:10;
			fill:none;
			stroke:currentColor;
			stroke-width:1.5;
			width: 100%;
			height: 100%;

			transform-origin: center center;
			transition: transform .2s ease;
		">
		<polyline
			style="
				transform-origin: center 48%;
				transition: transform .2s ease;
			"
			points="6 9 12 15 18 9"
		></polyline>
	</svg>`;

const chevronUpp =
	`<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24"
		style="
			overflow:visible;
			stroke-linecap:round;
			stroke-linejoin:round;
			stroke-miterlimit:10;
			fill:none;
			stroke:currentColor;
			stroke-width:1.5;
			width: 100%;
			height: 100%;

			transform-origin: center center;
			transition: transform .2s ease;
		">
		<polyline points="18 15 12 9 6 15"></polyline>
	</svg>`;

const frageteckenCirkel =
	`<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24"
		style="
			overflow:visible;
			stroke-linecap:round;
			stroke-linejoin:round;
			stroke-miterlimit:10;
			fill:none;
			stroke:currentColor;
			stroke-width:1.5;
			width: 100%;
			height: 100%;
		">
		<circle cx="12" cy="12" r="10"></circle>
		<path d="M9.09 9a3 3 0 0 1 5.83 1c0 2-3 3-3 3"></path>
		<line x1="12" y1="17" x2="12" y2="17"></line>
	</svg>`;

const mapp =
	`<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24"
		style="
			overflow:visible;
			stroke-linecap:round;
			stroke-linejoin:round;
			stroke-miterlimit:10;
			fill:none;
			stroke:currentColor;
			stroke-width:1.5;
			width: 100%;
			height: 100%;
		">
		<path d="M22 19a2 2 0 0 1-2 2H4a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h5l2 3h9a2 2 0 0 1 2 2z"/>
	</svg>`;

const anvandare =
	`<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24"
		style="
			overflow:visible;
			stroke-linecap:round;
			stroke-linejoin:round;
			stroke-miterlimit:10;
			fill:none;
			stroke:currentColor;
			stroke-width:1.5;
			width: 100%;
			height: 100%;
		">
		<path d="M20 21v-2a4 4 0 0 0-4-4H8a4 4 0 0 0-4 4v2"></path>
		<circle cx="12" cy="7" r="4"></circle>
	</svg>`;

const anvandarePlus =
	`<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24"
		style="
			overflow:visible;
			stroke-linecap:round;
			stroke-linejoin:round;
			stroke-miterlimit:10;
			fill:none;
			stroke:currentColor;
			stroke-width:1.5;
			width: 100%;
			height: 100%;
		">
		<path d="M16 21v-2a4 4 0 0 0-4-4H5a4 4 0 0 0-4 4v2"></path>
		<circle cx="8.5" cy="7" r="4"></circle>
		<line x1="20" y1="8" x2="20" y2="14"></line>
		<line x1="23" y1="11" x2="17" y2="11"></line>
	</svg>`;

const kopiera =
	`<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24"
		style="
			overflow:visible;
			stroke-linecap:round;
			stroke-linejoin:round;
			stroke-miterlimit:10;
			fill:none;
			stroke:currentColor;
			stroke-width:1.5;
			width: 100%;
			height: 100%;
		">
		<rect x="9" y="9" width="13" height="13" rx="2" ry="2"></rect>
		<path d="M5 15H4a2 2 0 0 1-2-2V4a2 2 0 0 1 2-2h9a2 2 0 0 1 2 2v1"></path>
	</svg>`;

const hanglas =
	`<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24"
		style="
			overflow:visible;
			stroke-linecap:round;
			stroke-linejoin:round;
			stroke-miterlimit:10;
			fill:none;
			stroke:currentColor;
			stroke-width:1.5;
			width: 100%;
			height: 100%;
		">
		<rect x="3" y="11" width="18" height="11" rx="2" ry="2"></rect>
		<path d="M7 11V7a5 5 0 0 1 10 0v4"></path>
	</svg>`;

const hanglasUpplast =
	`<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24"
		style="
			overflow:visible;
			stroke-linecap:round;
			stroke-linejoin:round;
			stroke-miterlimit:10;
			fill:none;
			stroke:currentColor;
			stroke-width:1.5;
			width: 100%;
			height: 100%;
		">
		<rect x="3" y="11" width="18" height="11" rx="2" ry="2"></rect>
		<path d="M7 11V7a5 5 0 0 1 9.9-1"></path>
	</svg>`;

const oga =
	`<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24"
		style="
			overflow:visible;
			stroke-linecap:round;
			stroke-linejoin:round;
			stroke-miterlimit:10;
			fill:none;
			stroke:currentColor;
			stroke-width:1.5;
			width: 100%;
			height: 100%;
		">
		<path d="M1 12s4-8 11-8 11 8 11 8-4 8-11 8-11-8-11-8z"></path>
		<circle cx="12" cy="12" r="3"></circle>
	</svg>`;

const ogaStruket =
	`<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24"
		style="
			overflow:visible;
			stroke-linecap:round;
			stroke-linejoin:round;
			stroke-miterlimit:10;
			fill:none;
			stroke:currentColor;
			stroke-width:1.5;
			width: 100%;
			height: 100%;
		">
		<path d="M17.94 17.94A10.07 10.07 0 0 1 12 20c-7 0-11-8-11-8a18.45 18.45 0 0 1 5.06-5.94M9.9 4.24A9.12 9.12 0 0 1 12 4c7 0 11 8 11 8a18.5 18.5 0 0 1-2.16 3.19m-6.72-1.07a3 3 0 1 1-4.24-4.24"></path>
		<line x1="1" y1="1" x2="23" y2="23"></line>
	</svg>`;

const hus =
	`<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24"
		style="
			overflow:visible;
			stroke-linecap:round;
			stroke-linejoin:round;
			stroke-miterlimit:10;
			fill:none;
			stroke:currentColor;
			stroke-width:1.5;
			width: 100%;
			height: 100%;
		">
		<path d="M3 9l9-7 9 7v11a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2z"></path>
		<polyline points="9 22 9 12 15 12 15 22"></polyline>
	</svg>`;

const husPlus =
	`<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24"
		style="
			overflow:visible;
			stroke-linecap:round;
			stroke-linejoin:round;
			stroke-miterlimit:10;
			fill:none;
			stroke:currentColor;
			stroke-width:1.5;
			width: 100%;
			height: 100%;
		">
		<path d="M20,13.7V20c0,1.1-0.9,2-2,2H4c-1.1,0-2-0.9-2-2V9l9-7l2.9,2.2"/>
		<polyline points="8,22 8,12 14,12 14,22"/>
		<line x1="19.3" y1="3.9" x2="19.3" y2="10.3"/>
		<line x1="22.5" y1="7.1" x2="16.1" y2="7.1"/>
	</svg>`;

const laddaNer =
	`<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24"
		style="
			overflow:visible;
			stroke-linecap:round;
			stroke-linejoin:round;
			stroke-miterlimit:10;
			fill:none;
			stroke:currentColor;
			stroke-width:1.5;
			width: 100%;
			height: 100%;
		">
		<path d="M21 15v4a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-4"></path>
		<polyline points="7 10 12 15 17 10"></polyline>
		<line x1="12" y1="15" x2="12" y2="3"></line>
	</svg>`;

const loggaIn =
	`<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24"
		style="
			overflow:visible;
			stroke-linecap:round;
			stroke-linejoin:round;
			stroke-miterlimit:10;
			fill:none;
			stroke:currentColor;
			stroke-width:1.5;
			width: 100%;
			height: 100%;
		">
		<path d="M15 3h4a2 2 0 0 1 2 2v14a2 2 0 0 1-2 2h-4"></path>
		<polyline points="10 17 15 12 10 7"></polyline>
		<line x1="15" y1="12" x2="3" y2="12"></line>
	</svg>`;

const loggaUt =
	`<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24"
		style="
			overflow:visible;
			stroke-linecap:round;
			stroke-linejoin:round;
			stroke-miterlimit:10;
			fill:none;
			stroke:currentColor;
			stroke-width:1.5;
			width: 100%;
			height: 100%;
		">
		<path d="M9 21H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h4"></path>
		<polyline points="16 17 21 12 16 7"></polyline>
		<line x1="21" y1="12" x2="9" y2="12"></line>
	</svg>`;

const plus =
	`<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24"
		style="
			overflow:visible;
			stroke-linecap:round;
			stroke-linejoin:round;
			stroke-miterlimit:10;
			fill:none;
			stroke:currentColor;
			stroke-width:1.5;
			width: 100%;
			height: 100%;
		">
		<line x1="12" y1="5" x2="12" y2="19"></line>
		<line x1="5" y1="12" x2="19" y2="12"></line>
	</svg>`;

const plusCirkel =
	`<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24"
		style="
			overflow:visible;
			stroke-linecap:round;
			stroke-linejoin:round;
			stroke-miterlimit:10;
			fill:none;
			stroke:currentColor;
			stroke-width:1.5;
			width: 100%;
			height: 100%;
		">
		<circle cx="12" cy="12" r="10"></circle>
		<line x1="12" y1="8" x2="12" y2="16"></line>
		<line x1="8" y1="12" x2="16" y2="12"></line>
	</svg>`;

const kugghjul =
	`<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24"
		style="
			overflow:visible;
			stroke-linecap:round;
			stroke-linejoin:round;
			stroke-miterlimit:10;
			fill:none;
			stroke:currentColor;
			stroke-width:1.5;
			width: 100%;
			height: 100%;
		">
		<circle cx="12" cy="12" r="3"></circle>
		<path d="M19.4 15a1.65 1.65 0 0 0 .33 1.82l.06.06a2 2 0 0 1 0 2.83 2 2 0 0 1-2.83 0l-.06-.06a1.65 1.65 0 0 0-1.82-.33 1.65 1.65 0 0 0-1 1.51V21a2 2 0 0 1-2 2 2 2 0 0 1-2-2v-.09A1.65 1.65 0 0 0 9 19.4a1.65 1.65 0 0 0-1.82.33l-.06.06a2 2 0 0 1-2.83 0 2 2 0 0 1 0-2.83l.06-.06a1.65 1.65 0 0 0 .33-1.82 1.65 1.65 0 0 0-1.51-1H3a2 2 0 0 1-2-2 2 2 0 0 1 2-2h.09A1.65 1.65 0 0 0 4.6 9a1.65 1.65 0 0 0-.33-1.82l-.06-.06a2 2 0 0 1 0-2.83 2 2 0 0 1 2.83 0l.06.06a1.65 1.65 0 0 0 1.82.33H9a1.65 1.65 0 0 0 1-1.51V3a2 2 0 0 1 2-2 2 2 0 0 1 2 2v.09a1.65 1.65 0 0 0 1 1.51 1.65 1.65 0 0 0 1.82-.33l.06-.06a2 2 0 0 1 2.83 0 2 2 0 0 1 0 2.83l-.06.06a1.65 1.65 0 0 0-.33 1.82V9a1.65 1.65 0 0 0 1.51 1H21a2 2 0 0 1 2 2 2 2 0 0 1-2 2h-.09a1.65 1.65 0 0 0-1.51 1z"></path>
	</svg>`;

const pilUppHoger =
	`<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24"
		style="
			overflow:visible;
			stroke-linecap:round;
			stroke-linejoin:round;
			stroke-miterlimit:10;
			fill:none;
			stroke:currentColor;
			stroke-width:1.5;
			width: 100%;
			height: 100%;
		">
		<line x1="7" y1="17" x2="17" y2="7"></line>
		<polyline points="7 7 17 7 17 17"></polyline>
	</svg>`;

const foretag =
	`<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24"
		style="
			overflow:visible;
			stroke-linecap:round;
			stroke-linejoin:round;
			stroke-miterlimit:10;
			fill:none;
			stroke:currentColor;
			stroke-width:1.5;
			width: 100%;
			height: 100%;
		">
		<line x1="1.459" y1="20.043" x2="22.456" y2="20.043"/>
		<polyline points="2.391,20.043 2.391,12.769 7.228,10.01 12.961,11.193 12.961,20.043"/>
		<line x1="7.228" y1="10.01" x2="7.228" y2="20.043"/>
		<polyline points="21.345,20.043 21.345,5.854 15.648,3.597 10.703,6.463 10.703,10.727"/>
		<line x1="15.648" y1="3.597" x2="15.648" y2="20.043"/>
	</svg>`;

const klocka =
	`<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24"
		style="
			overflow:visible;
			stroke-linecap:round;
			stroke-linejoin:round;
			stroke-miterlimit:10;
			fill:none;
			stroke:currentColor;
			stroke-width:1.5;
			width: 100%;
			height: 100%;
		">
		<circle cx="12" cy="12" r="10"></circle>
		<polyline points="12 6 12 12 16 14"></polyline>
	</svg>`;

const kalender =
	`<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24"
		style="
			overflow:visible;
			stroke-linecap:round;
			stroke-linejoin:round;
			stroke-miterlimit:10;
			fill:none;
			stroke:currentColor;
			stroke-width:1.5;
			width: 100%;
			height: 100%;
		">
			<rect x="3" y="4" width="18" height="18" rx="2" ry="2"></rect>
			<line x1="16" y1="2" x2="16" y2="6"></line>
			<line x1="8" y1="2" x2="8" y2="6"></line>
			<line x1="3" y1="10" x2="21" y2="10"></line>
	</svg>`;

const triangel =
	`<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24"
		style="
			overflow:visible;
			stroke-linecap:round;
			stroke-linejoin:round;
			stroke-miterlimit:10;
			fill:none;
			stroke:currentColor;
			stroke-width:1.5;
			width: 100%;
			height: 100%;
		">
			<path d="M10.29 3.86L1.82 18a2 2 0 0 0 1.71 3h16.94a2 2 0 0 0 1.71-3L13.71 3.86a2 2 0 0 0-3.42 0z"></path>
	</svg>`;

const infoCirkel =
	`<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24"
		style="
			overflow:visible;
			stroke-linecap:round;
			stroke-linejoin:round;
			stroke-miterlimit:10;
			fill:none;
			stroke:currentColor;
			stroke-width:1.5;
			width: 100%;
			height: 100%;
		">
			<circle cx="12" cy="12" r="10"></circle>
			<line x1="12" y1="16" x2="12" y2="12"></line>
			<line x1="12" y1="8" x2="12" y2="8"></line>
	</svg>`;

const bock =
	`<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24"
		style="
			overflow:visible;
			stroke-linecap:round;
			stroke-linejoin:round;
			stroke-miterlimit:10;
			fill:none;
			stroke:currentColor;
			stroke-width:1.5;
			width: 100%;
			height: 100%;
		">
			<polyline points="20 6 9 17 4 12"></polyline>
	</svg>`;

const pappersflygplan =
	`<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24"
		style="
			overflow:visible;
			stroke-linecap:round;
			stroke-linejoin:round;
			stroke-miterlimit:10;
			fill:none;
			stroke:currentColor;
			stroke-width:1.5;
			width: 100%;
			height: 100%;
		">
			<line x1="22" y1="2" x2="11" y2="13"></line>
			<polygon points="22 2 15 22 11 13 2 9 22 2"></polygon>
	</svg>`;

const kuvert =
	`<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24"
		style="
			overflow:visible;
			stroke-linecap:round;
			stroke-linejoin:round;
			stroke-miterlimit:10;
			fill:none;
			stroke:currentColor;
			stroke-width:1.5;
			width: 100%;
			height: 100%;
		">
			<path d="M4 4h16c1.1 0 2 .9 2 2v12c0 1.1-.9 2-2 2H4c-1.1 0-2-.9-2-2V6c0-1.1.9-2 2-2z"></path>
			<polyline points="22,6 12,13 2,6"></polyline>
	</svg>`;

const angra =
	`<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24"
		style="
			overflow:visible;
			stroke-linecap:round;
			stroke-linejoin:round;
			stroke-miterlimit:10;
			fill:none;
			stroke:currentColor;
			stroke-width:1.5;
			width: 100%;
			height: 100%;
		">
			<polyline points="2.4 9.35 2.4 15.35 8.4 15.35"/>
			<path d="M21.89,14.35A9,9,0,0,0,7.04,10.99L2.4,15.35"/>
	</svg>`;

const skrivare =
	`<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24"
		style="
			overflow:visible;
			stroke-linecap:round;
			stroke-linejoin:round;
			stroke-miterlimit:10;
			fill:none;
			stroke:currentColor;
			stroke-width:1.5;
			width: 100%;
			height: 100%;
		">
			<polyline points="6 9 6 2 18 2 18 9"></polyline>
			<path d="M6 18H4a2 2 0 0 1-2-2v-5a2 2 0 0 1 2-2h16a2 2 0 0 1 2 2v5a2 2 0 0 1-2 2h-2"></path>
			<rect x="6" y="14" width="12" height="8"></rect>
	</svg>`;

const stapeldiagram =
	`<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24"
		style="
			overflow:visible;
			stroke-linecap:round;
			stroke-linejoin:round;
			stroke-miterlimit:10;
			fill:none;
			stroke:currentColor;
			stroke-width:1.5;
			width: 100%;
			height: 100%;
		">
			<line x1="18" y1="20" x2="18" y2="10"></line>
			<line x1="12" y1="20" x2="12" y2="4"></line>
			<line x1="6" y1="20" x2="6" y2="14"></line>
	</svg>`;

const externLank =
	`<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24"
		style="
			overflow:visible;
			stroke-linecap:round;
			stroke-linejoin:round;
			stroke-miterlimit:10;
			fill:none;
			stroke:currentColor;
			stroke-width:1.5;
			width: 100%;
			height: 100%;
		">
			<path d="M18 13v6a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V8a2 2 0 0 1 2-2h6"></path>
			<polyline points="15 3 21 3 21 9"></polyline>
			<line x1="10" y1="14" x2="21" y2="3"></line>
	</svg>`;

const nalLutad =
	`<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24"
		style="
			overflow:visible;
			stroke-linecap:round;
			stroke-linejoin:round;
			stroke-miterlimit:10;
			fill:none;
			stroke:currentColor;
			stroke-width:1.5;
			width: 100%;
			height: 100%;
		">
			<polygon points="6.926 9.537 11.622 9.52 15.424 5.718 14.115 4.41 19.892 10.187 18.595 8.889 14.793 12.691 14.78 17.391 14.076 18.095 10.149 14.168 6.222 10.241 6.926 9.537"/>
			<line x1="10.149" y1="14.168" x2="4.752" y2="19.564"/>
	</svg>`;

const gem =
	`<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24"
		style="
			overflow:visible;
			stroke-linecap:round;
			stroke-linejoin:round;
			stroke-miterlimit:10;
			fill:none;
			stroke:currentColor;
			stroke-width:1.5;
			width: 100%;
			height: 100%;
		">
			<path d="M3.9,12.017l7.561-7.561a5.066,5.066,0,0,1,7.165,0h0a5.066,5.066,0,0,1,0,7.165l-8.67,8.67a2.514,2.514,0,0,1-3.556,0h0a2.514,2.514,0,0,1,0-3.556l8.714-8.714" />
	</svg>`;

const zoomaIn =
	`<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24"
		style="
			overflow:visible;
			stroke-linecap:round;
			stroke-linejoin:round;
			stroke-miterlimit:10;
			fill:none;
			stroke:currentColor;
			stroke-width:1.5;
			width: 100%;
			height: 100%;
		">
		<circle cx="11" cy="11" r="8"></circle>
		<line x1="21" y1="21" x2="16.65" y2="16.65"></line>
		<line x1="11" y1="8" x2="11" y2="14"></line>
		<line x1="8" y1="11" x2="14" y2="11"></line>
	</svg>`;

const zoomaUt =
	`<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24"
		style="
			overflow:visible;
			stroke-linecap:round;
			stroke-linejoin:round;
			stroke-miterlimit:10;
			fill:none;
			stroke:currentColor;
			stroke-width:1.5;
			width: 100%;
			height: 100%;
		">
		<circle cx="11" cy="11" r="8"></circle>
		<line x1="21" y1="21" x2="16.65" y2="16.65"></line>
		<line x1="8" y1="11" x2="14" y2="11"></line>
	</svg>`;

const dokumentsidaMedText =
	`<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24"
		style="
			overflow:visible;
			stroke-linecap:round;
			stroke-linejoin:round;
			stroke-miterlimit:10;
			fill:none;
			stroke:currentColor;
			stroke-width:1.5;
			width: 100%;
			height: 100%;
		">
		<path d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z"></path>
		<polyline points="14 2 14 8 20 8"></polyline>
		<line x1="16" y1="13" x2="8" y2="13"></line>
		<line x1="16" y1="17" x2="8" y2="17"></line>
		<polyline points="10 9 9 9 8 9"></polyline>
	</svg>`;


//################################################################################################

// En del lite större...

const pil1 =
	`<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 143 201"
		style="
			overflow:visible;
			stroke-linecap:round;
			stroke-linejoin:round;
			stroke-miterlimit:10;
			fill:currentColor;
			fill-rule: evenodd;
			stroke:none;
			stroke-width:0;
			width: 100%;
			height: 100%;
		">
		<path d="M43.814,173.9c8.082-3.654,15.682-7.9,24.663-8.73,2.863-.265,8.552-1.369,10.007,2.19,1.8,4.393-3.6,4.957-6.529,5.68-7.845,1.934-15.367,5.106-21.6,10.34-3.587,3.009-6.154,6.51-8.836,10.3-1.62,2.288-3,4.942-6.206,4.318-3.364-.656-5.732-5.89-7.341-8.451-2.515-4.006-4.887-8.1-7.295-12.173s-4.838-8.156-7.466-12.1c-2.581-3.874-6.812-7.743-8.766-11.929-3.41-7.307,4.629-13.63,10.134-7.174,6.481,7.6,11.494,16.995,16.56,25.56,4.809-3.331,4.763-12.478,5.968-17.6a174.4,174.4,0,0,1,6.626-21.463,258.2,258.2,0,0,1,19.9-40.651C79.149,65.844,98,41.581,118.465,19.108c4.258-4.676,8.819-11.061,14.357-14.3,6.274-3.672,9.8,2.567,6.119,7.794-5.524,7.841-13.223,14.5-19.564,21.693-18.939,21.471-36.4,44.516-50.428,69.52a208.059,208.059,0,0,0-17.877,40.606C48.111,154.083,47.226,164.414,43.814,173.9Z"/>
	</svg>`;


//################################################################################################

// Alla ikoner:

//const kugghjul = import('/content/images/svg/feather/settings.svg')
//	.then(x => console.log(x));

export default {

	angra: angra,
	anvandare: anvandare,
	anvandarePlus: anvandarePlus,
	bock: bock,
	burgare: burgare,
	burgarePunkter: burgarePunkter,
	chevronNer: chevronNer,
	chevronUpp: chevronUpp,
	dokumentsidaMedText: dokumentsidaMedText,
	externLank: externLank,
	foretag: foretag,
	frageteckenCirkel: frageteckenCirkel,
	gem: gem,
	hanglas: hanglas,
	hanglasUpplast: hanglasUpplast,
	hus: hus,
	husPlus: husPlus,
	infoCirkel: infoCirkel,
	kalender: kalender,
	karta: karta,
	klocka: klocka,
	kopiera: kopiera,
	kryss: kryss,
	kugghjul: kugghjul,
	laddaNer: laddaNer,
	loggaIn: loggaIn,
	loggaSnigel: loggaSnigel,
	loggaUt: loggaUt,
	mapp: mapp,
	//nal: nal,
	nalLutad: nalLutad,
	oga: oga,
	ogaStruket: ogaStruket,
	pappersflygplan: pappersflygplan,
	papperskorg: papperskorg,
	//penna: penna,
	pennaRitar: pennaRitar,
	pil1: pil1,
	pilUppHoger: pilUppHoger,
	plus: plus,
	plusCirkel: plusCirkel,
	skrivare: skrivare,
	stapeldiagram: stapeldiagram,
	triangel: triangel,
	utelast: hanglas,
	kuvert: kuvert,
	zoomaIn: zoomaIn,
	zoomaUt: zoomaUt,

	// Namnmappade till operation/innebörd/användning:

	andra: pennaRitar,
	arkivfil: gem,
	aterstallLosen: angra,
	license: foretag,
	diagram: stapeldiagram,
	doljLosen: ogaStruket,
	fast: nalLutad,
	felmeddelande: triangel,
	flytta: pilUppHoger,
	fragemeddelande: frageteckenCirkel,
	hem: hus,
	hjalpknapp: frageteckenCirkel,
	impersonera: anvandarePlus,
	informationsmeddelande: infoCirkel,
	installningar: kugghjul,
	klona: kopiera,
	laggTillPaOversiktssida: hus,
	lyckatmeddelande: bock,
	mail: kuvert,
	mejl: kuvert,
	ny: plus,
	nyAnvandare: anvandarePlus,
	om: infoCirkel,
	oversikt: hus,
	rakenskapsar: kalender,
	rapportgrupp: mapp,
	skicka: pappersflygplan,
	skrivUt: skrivare,
	stang: kryss,
	taBort: papperskorg,
	undermenyPil: triangel,
	varningsmeddelande: triangel,
	visaLosen: oga,
	zoomaTillHelSida: dokumentsidaMedText,
}

